export default "__VITE_ASSET__CSLetkKG__"